import React from 'react';

const FarmPlant = ({ menuOpen, plant, farm }) => {
  return (
    <div
      className={`flex flex-wrap justify-center mt-10 px-5 md:px-0 ${
        menuOpen ? 'pl-8 md:pl-24' : ''
      }`}
    >
      <div className="w-full md:w-4/5 lg:w-133 bg-white rounded px-3 md:px-6 py-4">
        <div className="flex flex-wrap">
          <h6>Plant Record</h6>

          <div className="flex ml-32">
            <img
              className="block h-10"
              src={farm.product.crop.imageUrl}
              alt={farm.product.crop.name}
            />

            <div className="ml-6">
              <p className="font-header">{farm.name}</p>
              <span className="block text-xx -mt-1">
                {farm.product.location.name},{farm.product.location.state} -{' '}
                {farm.product.location.country}
              </span>
            </div>
          </div>

          <div className="mt-8 bg-cf-100 rounded p-4 text-cf-300 w-full md:ml-48">
            <div className="flex justify-between items-center">
              <div>
                <p className="font-header">{plant.population}</p>
                <span className="block text-tiny">Plant</span>
                <span className="block text-tiny -mt-3">population</span>
              </div>

              <div>
                <p className="font-header">{plant.health}</p>
                <span className="block text-tiny">Plant</span>
                <span className="block text-tiny -mt-3">health</span>
              </div>

              <div>
                <p className="font-header">{plant.stage}</p>
                <span className="block text-tiny">Growing</span>
                <span className="block text-tiny -mt-3">stage</span>
              </div>

              <div>
                <p className="font-header">{plant.chlorophyl}</p>
                <span className="block text-tiny">Chlorophyl</span>
                <span className="block text-tiny -mt-3">index</span>
              </div>

              <div>
                <p className="font-header">{plant.productivity}</p>
                <span className="block text-tiny">Crop</span>
                <span className="block text-tiny -mt-3">productivity</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmPlant;
